import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Skeleton,
  Row,
  Col,
  Space,
  notification,
  Form,
} from "antd";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { CloseOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
/* custom component */
import {
  ViewBox,
  ViewLabel,
  ViewValue,
  PageContainer,
  Xpagination,
  Xtable,
} from "../../../component/Xcomponent";

import config from "../../../config";
import { dateToString, getDoctorToken } from "../../../utils";
/* action */
import {
  getViewConsultation,
  getViewConsultationReset,
} from "../../../action/getViewConsultation";
import getViewConsultationApi from "../../../api/getViewConsultationApi";

import {
  convertTZ,
  dateTimeFormat,
  dateTimeUTCFormat,
  timeSlotFormat,
  dateFormat,
  timeSlotFormatWithoutAM,
} from "../../../utils";
import {
  InputBox,
  RangePickerBox,
  SelectBox,
  XButton,
} from "./ConsultationViewStyle";
import AppointmentView from "../../Appointments/AppointmentView/AppointmentView";
const ConsultationView = (props) => {
  /* variable */
  const {
    getViewConsultation,
    getViewConsultationReset,
    getViewConsultationState,
    datb,
  } = props;
  const [Datalist, setDatalist] = useState([]);
  const [Plist, setPlist] = useState([]);
  const search = useLocation().search;

  const docid = props.match?.params?.id || null;
  const initialSearchData = {
    patient_name: "",
    patient_phone: "",
    appointment_no: "",
    appointment_start_date: "",
    appointment_end_date: "",
    appointment_type: "",
    status: "",
  };
  const [view, setView] = useState({
    visible: false,
    id: null,
  });
  const [searchData, setSearchData] = useState(initialSearchData);
  const [refresh, setRefresh] = useState(0);

  const [tableData, setTableData] = useState([]);
  const [loadingTableData, setLoadingTableData] = useState(false);
  const page = new URLSearchParams(search).get("page");
  const [pagination, setPagination] = useState({
    page: page ? page : 1,
    records: 10,
  });
  /* callbacks */

  function getSpeciality(spec) {
    let QuaValues = [];
    for (let i = 0; i < spec.length; i++) {
      QuaValues[i] = spec[i].value;
    }
    return QuaValues.join(" , ");
  }
  function getAge(dateString) {
    var today = new Date();
    var expDate = new Date(dateString);
    var experience = today.getFullYear() - expDate.getFullYear();
    var m = today.getMonth() - expDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < expDate.getDate())) {
      experience--;
    }
    return experience;
  }
  //const columns = [

  //    {
  //        title: "Doctor Name",
  //        dataIndex: "doctor_id",
  //        key: "doctor_id",
  //        render: (doctor_id) => (
  //            <span style={{ fontWeight: 600 }}>{doctor_id.fname}{doctor_id.lname}</span>
  //        ),
  //    },

  //    {
  //        title: "Qualification",
  //        dataIndex: "doctor_id",
  //        key: "doctor_id",
  //        render: (doctor_id) => (
  //            <span style={{ fontWeight: 600 }}>{doctor_id.qualification}</span>
  //        ),
  //    },
  //    {
  //        title: "Speciality",
  //        dataIndex: "doctor_id",
  //        key: "doctor_id",
  //        render: (doctor_id) => (
  //            <>
  //                <span style={{ fontWeight: 600 }} >{getSpeciality(doctor_id.speciality)}</span>

  //            </>
  //        ),
  //    },
  //    {
  //        title: "Exprience",
  //        dataIndex: "doctor_id",
  //        key: "doctor_id",
  //        render: (doctor_id) => (
  //            <>
  //                <span style={{ fontWeight: 600 }} >{getAge(doctor_id.exprience)}</span>

  //            </>
  //        ),
  //    },

  //]
  const columns = [
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (data) => (
        <>
          <span style={{ fontWeight: 600 }}>
            {timeSlotFormat(data.time_slot_start)}
          </span>
          <br />
          <span>{timeSlotFormat(data.time_slot_end)}</span>
        </>
      ),
    },
    {
      title: "Appointment Date",
      dataIndex: "date",
      key: "appintmentdate",
      render: (data) => <span style={{ fontWeight: 600 }}>{data}</span>,
    },
    {
      title: "Patient",
      dataIndex: "pname",
      key: "pname",
      render: (data) => <span style={{ fontWeight: 600 }}>{data}</span>,
    },
    {
      title: "Appointment No.",
      dataIndex: "appNo",
      key: "appNo",
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
    },
    {
      title: "Booked Date",
      dataIndex: "bookedDate",
      key: "bookeddate",
    },
    {
      title: "Amount Paid",
      dataIndex: "amountpaid",
      key: "amountpaid",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <>
          {status === "not attended" && (
            <span
              style={{ width: "fit-content" }}
              className="not-attended booked-status d-flex"
            >
              {status}
            </span>
          )}
          {status === "pending" && (
            <span
              style={{ width: "fit-content" }}
              className="pending booked-status d-flex"
            >
              {status}
            </span>
          )}
          {status === "cancelled" && (
            <span
              style={{ width: "fit-content" }}
              className="cancelled booked-status d-flex"
            >
              {status}
            </span>
          )}
          {status === "completed" && (
            <span
              style={{ width: "fit-content" }}
              className="completed booked-status d-flex"
            >
              {status}
            </span>
          )}
        </>
      ),
    },
    {
      title: "Action",
      key: "id",
      dataIndex: "id",
      render: (data) => (
        <Space size="small">
          <Button
            size="small"
            // shape="circle"
            text="Details"
            icon={<EyeOutlined style={{ color: "#883DA9" }} />}
            onClick={() => setView({ id: data.id, visible: true })}
          />
        </Space>
      ),
    },
  ];
  useEffect(() => {
    if (docid) {
      setLoadingTableData(true);
      fetch(
        `${config.api.base_url}patient/view-consultation?id=${docid}&page=${pagination.page}&records=${pagination.records}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getDoctorToken()}`,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          setLoadingTableData(false);
          let tableData = [];
          resp.data.result.map((data) => {
            let date = moment(data.to_date).utc().unix();
            let current_date = convertTZ(
              moment().format("YYYY-MM-DD HH:mm:ss") + " +0000",
              "Asia/Kolkata"
            );
            current_date = moment(current_date).utc().unix();
            let show = false;
            if (date <= current_date) {
              show = true;
            }
            tableData.push({
              time: {
                time_slot_start: data.time_slot_start,
                time_slot_end: data.time_slot_end,
              },
              appNo: data.appointment_no,
              pname: data.some_one_else
                ? data.full_name
                : data.patient_id
                ? `${data.patient_id?.name?.firstName} ${data.patient_id?.name?.lastName}`
                : "",
              date: dateToString(data.date),
              email: data.some_one_else ? data.email : data.patient_id?.email,
              contact: data.some_one_else ? data.phone : data.patient_id?.phone,
              bookedDate: dateFormat(data.createdAt),
              amountpaid: data.total_amount,
              status: data.status,
              id: {
                id: data._id,
                status: data.status,
                payment_status: data.payment_status,
                show: show,
              },
            });
          });
          tableData = _.orderBy(tableData);
          setTableData(tableData);
          setPlist(resp.data);
          setDatalist(resp.data.result);
        });
      });
    }
  }, [pagination, refresh]);

  return (
    //<Drawer
    //    title={`Consultation View`}
    //    placement="right"
    //    onClose={props.onClose}
    //    visible={props.visible}
    //    width={800}
    //>

    //        <Row gutter={20} >
    //        {Datalist ? Datalist.map(item => (
    //            <>
    //               <Col span="12">
    //                <ViewBox>
    //                    <ViewLabel>Name</ViewLabel>
    //                        <ViewValue><span>{item?.doctor_id.fname} {item?.doctor_id.lname}</span></ViewValue>
    //                    </ViewBox>
    //            </Col>
    //                  <Col span="12">
    //                <ViewBox>
    //                        <ViewLabel>Gualification</ViewLabel>
    //                        <ViewValue><span>{item?.doctor_id.qualification}</span></ViewValue>
    //                    </ViewBox>
    //                </Col>
    //                <Col span="12">
    //                    <ViewBox>
    //                        <ViewLabel>Speciality</ViewLabel>
    //                        <ViewValue><span>{getSpeciality(item?.doctor_id.speciality)}</span></ViewValue>
    //                    </ViewBox>
    //                </Col>
    //                <Col span="12">
    //                    <ViewBox>
    //                        <ViewLabel>Exprience</ViewLabel>
    //                        <ViewValue><span>{getAge(item?.doctor_id.exprience)}</span></ViewValue>
    //                    </ViewBox>
    //                </Col>
    //            </>
    //                )) :"" }
    //            </Row>

    //</Drawer >
    <PageContainer>
      <div className="Appointment list">
        <Xtable
          loading={loadingTableData}
          size="middle"
          columns={columns}
          dataSource={tableData}
          pagination={false}
          scroll={{ x: 768 }}
        />
        <Xpagination
          style={{ gap: "5px", flexWrap: "wrap" }}
          pageSizeOptions={["10", "25", "50", "100", "500"]}
          showSizeChanger
          total={Plist.pagination?.total_records}
          onChange={(page, pageSize) =>
            setPagination({ page: page, records: pageSize })
          }
          current={pagination.page}
          defaultPageSize={pagination.records}
          defaultCurrent={1}
        />
        <AppointmentView
          id={view.id}
          visible={view.visible}
          jit={searchData.appointment_type}
          onClose={() => setView({ visible: false, id: null })}
        />
      </div>
    </PageContainer>
  );
};

const mapStateToProps = (state) => ({
  getViewConsultationState: state.getViewConsultation,
});

const mapDispatchToProps = (dispatch) => ({
  getViewConsultation: (params) => dispatch(getViewConsultation(params)),
  getViewConsultationReset: () => dispatch(getViewConsultationReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationView);
